module.exports = __webpack_public_path__ + "img/2-3.2291173f.svg";